import { Signal } from "@preact/signals";
import { MarqueeListener } from "./interfaces";

const ALLOW_DELTA = 16;

const listeners = new Set<MarqueeListener>();
const initialCoord = { x: 0, y: 0 };
let isListening = false;

const handleTouchEnd = () => {
    listeners.forEach(({ isPopup, cancelLongPress }) => {
        cancelLongPress();

        if (isPopup.peek()) {
            isPopup.value = false;
        }
    });
};

const handleTouchMove = (event: TouchEvent) => {
    const touch = event.touches[0];

    const deltaX = Math.abs(touch.clientX - initialCoord.x);
    const deltaY = Math.abs(touch.clientY - initialCoord.y);

    if (deltaX > ALLOW_DELTA || deltaY > ALLOW_DELTA) {
        handleTouchEnd();
    }
};

const startListening = () => {
    if (isListening) {
        return;
    }

    window.addEventListener("touchend", handleTouchEnd);
    window.addEventListener("touchcancel", handleTouchEnd);
    window.addEventListener("touchmove", handleTouchMove);
    isListening = true;
};

const stopListening = () => {
    if (listeners.size > 0) {
        return;
    }

    window.removeEventListener("touchend", handleTouchEnd);
    window.removeEventListener("touchcancel", handleTouchEnd);
    window.removeEventListener("touchmove", handleTouchMove);
    isListening = false;
};

export const registerMarquee = (
    isPopup: Signal<boolean>,
    cancelLongPress: () => void,
) => {
    const listener = { isPopup, cancelLongPress };

    listeners.add(listener);
    startListening();

    return () => {
        listeners.delete(listener);
        stopListening();
    };
};

export const setInitialTouch = (x: number, y: number) => {
    initialCoord.x = x;
    initialCoord.y = y;
};
